
import { Button, Flex } from 'rebass';
import PropTypes from 'prop-types';
import React from 'react';
import store from 'store';

const NewStoryFooter = ({ onCancel, nextButtonText = "Next", onBack, onNext, disabled }) => {
  const isRespondingToRequest = store.get('requestResponse') === 'true';

  return (
    <Flex width="100%" justifyContent="space-between" alignItems="center" bg="white" p={2} sx={{ position: 'fixed', bottom: 0, display: ['flex', 'none'], zIndex: 3 }}>
      {!isRespondingToRequest && onCancel && (
        <Button
          disabled={disabled}
          type="button"
          fontSize={16}
          fontFamily="Poppins"
          fontWeight={500}
          lineHeight="120%"
          letterSpacing="-0.352px"
          variant="transparent"
          onClick={onCancel}
          color="#64748B"
          css="grid-column: 1 / 2; justify-self: start;"
        >
          Cancel
        </Button>
      )}
      {onBack && (
        <Button
          type="button"
          fontSize={16}
          fontFamily="Poppins"
          fontWeight={500}
          lineHeight="120%"
          letterSpacing="-0.352px"
          color="#9B59B6"
          padding={0}
          variant="transparent"
          onClick={onBack}
          css="grid-column: 1 / 2; justify-self: start;"
        >
          {'<'} Back
        </Button>
      )}
      {onNext && (
        <Button
          height={40}
          py={1}
          px={5}
          onClick={onNext}
          sx={{ borderRadius: '23px', opacity: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          {nextButtonText}
        </Button>
      )}
    </Flex>
  );
};

NewStoryFooter.propTypes = {
  onCancel: PropTypes.func,
  onBack: PropTypes.func,
  onNext: PropTypes.func,
  title: PropTypes.string,
  disabled: PropTypes.bool,
};

NewStoryFooter.defaultProps = {
  onCancel: null,
  onBack: null,
  onNext: null,
  title: '',
  disabled: false,
};

export default NewStoryFooter;
